import BaseComponent from '@/components/base';
import { goalsMap } from '@/utils/goals-map';

export default class HairGoals extends BaseComponent {
  render() {
    this.selectedButtons = [];
    this.goals = goalsMap.hair.slice(0, 5);
    return `
      <style>
      .title {
      font-size: 18px;
        line-height: 28px;
        letter-spacing: .54px;
      }
      .text {
      font-size: 16px;
        line-height: 24px;
        letter-spacing: .32px;
      }
        button {
          margin: 5px;
          padding: 10px;
          font-size: 1em;
          color: black;
          background-color: white;
          cursor: pointer;
          border-radius: 10px;
          border-color: #8ae5d3;
          border-style: solid;
        }
        button.selected {
          background-color: #d2eae5;
        }

         button:hover {
          background-color: #d2eae5;
        }
      </style>

    <div class="title">What are your hair goals?</div>
    <div>
    ${this.goals
      .map(
        (goal) =>
          `<button class="text" value="${goal.dataKey}"> ${goal.name}</button>`
      )
      .join('')}
    </div>

    `;
  }

  afterMount() {
    this.shadowRoot
      .querySelectorAll('button')
      .forEach((button) =>
        button.addEventListener('click', () => this.handleButtonClick(button))
      );
  }

  handleButtonClick(button) {
    const buttonName = button.textContent;

    if (this.selectedButtons.includes(buttonName)) {
      this.selectedButtons = this.selectedButtons.filter(
        (name) => name !== buttonName
      );
      button.classList.remove('selected');
    } else {
      if (this.selectedButtons.length >= 5) {
        const firstSelectedButtonName = this.selectedButtons.shift();
        const firstSelectedButton = Array.from(
          this.shadowRoot.querySelectorAll('button')
        ).find((btn) => btn.textContent === firstSelectedButtonName);
        firstSelectedButton.classList.remove('selected');
      }
      this.selectedButtons.push(buttonName);
      button.classList.add('selected');
    }

    this.updateSelectedList();
  }

  updateSelectedList() {
    const selectedButtons = Array.from(
      this.shadowRoot.querySelectorAll('button.selected')
    );
    const values = selectedButtons.map((x) => x.value);

    this.setAttribute('value', JSON.stringify(values));

    this.dispatchEvent(
      new CustomEvent('quizHairGoalsChange', {
        detail: { value: values },
        bubbles: true,
        composed: true
      })
    );

    document.querySelector('buy-once-regimen').enableHairGoals = true;

    const buyOnce = document.querySelector('buy-once-regimen');
    if (
      buyOnce.enableFragrance &&
      buyOnce.enableHairGoals &&
      buyOnce.enableHairTypes
    ) {
      const button2 = buyOnce.shadowRoot.querySelector('button');

      button2.removeAttribute('disabled');
    }
  }
}
